(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ut-collection-grid-control"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ut-collection-grid-control')) {
  customElements.define('ut-collection-grid-control', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.section = this.closest('section[data-section-id]');
      if (!this.section) return;
      const valid = value => ['large', 'medium', 'small'].includes(value);
      let saved = 'medium';
      try { const value = sessionStorage.getItem('ut-collection-density'); if (valid(value)) saved = value; } catch {}
      this.applyDensity(saved);
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-density]');
        if (!button || !this.contains(button) || !valid(button.dataset.density)) return;
        this.applyDensity(button.dataset.density);
        try { sessionStorage.setItem('ut-collection-density', button.dataset.density); } catch {}
      }, {signal: this.controller.signal});
    }
    applyDensity(value) {
      this.section.dataset.utDensity = value;
      this.querySelectorAll('button[data-density]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.density === value)));
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ut-collection-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ut-collection-navigation')) {
  customElements.define('ut-collection-navigation', class extends HTMLElement {
    connectedCallback() {
      const current = new URL(window.location.href);
      this.querySelectorAll('a[data-ut-filter-link]').forEach(link => {
        const target = new URL(link.href, current.origin);
        for (const [key, value] of current.searchParams) {
          if (key !== 'page' && key !== 'section_id' && key !== 'sections') {
            target.searchParams.delete(key);
          }
        }
        for (const [key, value] of current.searchParams) {
          if (key !== 'page' && key !== 'section_id' && key !== 'sections') target.searchParams.append(key, value);
        }
        link.href = target.href;
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ut-ring-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ut-ring-guide')) {
  customElements.define('ut-ring-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) {
        this.visibilityObserver.observe(this.closest('.product-modal'), {attributes:true, attributeFilter:['style','class']});
        return;
      }
      this.ready = true;
      const modal = this.closest('.product-modal');
      const syncVisibility = () => modal.setAttribute('aria-hidden', String(getComputedStyle(modal).display === 'none'));
      this.visibilityObserver = new MutationObserver(syncVisibility);
      this.visibilityObserver.observe(modal, {attributes:true, attributeFilter:['style','class']});
      syncVisibility();
      this.rows = Array.from(this.querySelectorAll('[data-guide-row]'));
      this.system = this.querySelector('[data-guide-system]');
      this.value = this.querySelector('[data-guide-value]');
      this.measurement = this.querySelector('[data-guide-measurement]');
      this.result = this.querySelector('[data-guide-result]');
      this.error = this.querySelector('[data-guide-error]');
      this.apply = this.querySelector('[data-guide-apply]');
      this.system.addEventListener('change', () => this.setupSystem());
      this.value.addEventListener('change', () => this.convert());
      this.measurement.addEventListener('input', () => this.convert());
      this.apply.addEventListener('click', () => this.applySize());
      this.querySelectorAll('[data-guide-pick]').forEach(button => button.addEventListener('click', () => {
        this.system.value = 'us';
        this.setupSystem();
        this.value.value = button.dataset.guidePick;
        this.convert();
        this.querySelector('.ut-guide-scroll').scrollTo({top: 0, behavior: 'auto'});
      }));
      this.querySelectorAll('[data-guide-tab]').forEach((button, index, tabs) => {
        button.addEventListener('click', () => this.showTab(button.dataset.guideTab));
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          this.showTab(tabs[next].dataset.guideTab);
          tabs[next].focus();
        });
      });
      this.querySelectorAll('[data-guide-measure-with]').forEach(button => button.addEventListener('click', () => {
        this.showTab('convert');
        this.system.value = button.dataset.guideMeasureWith;
        this.setupSystem();
        this.measurement.focus();
      }));
      this.setupSystem();
    }
    disconnectedCallback() { this.visibilityObserver?.disconnect(); }
    showTab(name) {
      this.querySelectorAll('[data-guide-tab]').forEach(tab => {
        const selected = tab.dataset.guideTab === name;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.querySelectorAll('[data-guide-panel]').forEach(panel => panel.hidden = panel.dataset.guidePanel !== name);
      this.querySelector('.ut-guide-scroll').scrollTop = 0;
    }
    setupSystem() {
      const system = this.system.value;
      const measurementMode = system === 'diameter' || system === 'circumference';
      this.querySelector('[data-guide-input-label]').hidden = !measurementMode;
      this.querySelector('[data-guide-select-label]').hidden = measurementMode;
      this.result.hidden = true;
      this.error.hidden = true;
      this.measurement.value = '';
      this.rows.forEach(row => delete row.dataset.selected);
      this.value.replaceChildren(new Option(this.dataset.prompt, ''));
      const start = system === 'us' ? 5 : system === 'uk' ? 9.5 : 49;
      const end = system === 'us' ? 12 : system === 'uk' ? 23.5 : 67;
      const step = system === 'eu' ? 1 : .5;
      if (measurementMode) return;
      for (let value = start; value <= end; value += step) {
        const label = system === 'uk' ? String.fromCharCode(65 + Math.floor(value)) + (value % 1 ? '½' : '') : String(value);
        this.value.add(new Option(label, String(value)));
      }
    }
    convert() {
      const system = this.system.value;
      const measurementMode = system === 'diameter' || system === 'circumference';
      const raw = measurementMode ? this.measurement.value.trim().replace(',', '.') : this.value.value;
      this.error.hidden = true;
      this.result.hidden = true;
      this.rows.forEach(row => delete row.dataset.selected);
      if (!raw) return;
      const value = Number(raw);
      const key = system === 'uk' ? 'ukNumber' : system;
      const valid = /^\d+(\.\d+)?$/.test(raw) && Number.isFinite(value);
      if (!valid || value <= 0) return this.showError(this.dataset.invalid);
      const first = Number(this.rows[0].dataset[key]);
      const last = Number(this.rows[this.rows.length - 1].dataset[key]);
      if (value < first || value > last) return this.showError(this.dataset.outside);
      const row = this.rows.reduce((best, candidate) => Math.abs(Number(candidate.dataset[key]) - value) <= Math.abs(Number(best.dataset[key]) - value) ? candidate : best);
      const exact = Math.abs(Number(row.dataset[key]) - value) < .01;
      this.selectedRow = row;
      row.dataset.selected = 'true';
      this.querySelector('[data-guide-match]').textContent = exact ? this.dataset.exact : this.dataset.approx;
      this.querySelector('[data-guide-output]').textContent = 'US ' + row.dataset.us;
      this.querySelector('[data-guide-detail]').textContent = 'UK ' + row.dataset.uk + ' · EU ' + row.dataset.eu + ' · ' + row.dataset.diameter + ' mm';
      const available = row.dataset.available === 'true';
      const offered = row.dataset.offered === 'true';
      this.apply.disabled = !available || !offered;
      this.apply.textContent = !offered ? this.dataset.notOffered : !available ? this.dataset.soldOut : this.dataset.apply.replace('[size]', row.dataset.us);
      this.result.hidden = false;
    }
    showError(message) { this.error.textContent = message; this.error.hidden = false; }
    applySize() {
      if (!this.selectedRow || this.apply.disabled) return;
      const form = this.closest('form');
      if (!form) return;
      const size = this.selectedRow.dataset.us;
      const input = Array.from(form.querySelectorAll('[data-single-option-selector]')).find(el => el.dataset.index === this.dataset.optionIndex && el.value === size);
      if (!input || input.disabled) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', {bubbles:true}));
      this.closest('.product-modal').querySelector('.product-modal__close').click();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
